import React from 'react';
import {VideoQuality} from "@zoom/videosdk";

const EventHandler = (props: {
    client: any,
    setAllParticipants: any,
    setActiveSpeaker: any,
    activeUser: any,
    myUser: any,
    allParticipants: any,
    setCurrentUser: any
}) => {
    const {client, setAllParticipants, setActiveSpeaker, activeUser, myUser, allParticipants, setCurrentUser} = props;

    const onActiveChange = React.useCallback((e: any) => {
        if (e && e.length > 0 && e[0].userId !== activeUser?.userId && myUser?.userId && e[0].userId !== myUser?.userId) {
            changeActiveSpeaker(e[0]);
        }
    }, [activeUser, myUser])


    React.useEffect(() => {
        const otherParticipants = allParticipants.filter((item: any) => item.userId !== myUser?.userId)
        const isActiveUserAvailable = otherParticipants.find((item: any) => item.userId === activeUser?.userId)
        if (!isActiveUserAvailable) {
            if (otherParticipants.length === 1) {
                changeActiveSpeaker(otherParticipants[0])
            } else if (myUser){
                    changeActiveSpeaker(myUser)
            }else{
                console.warn("No active user")
            }
        }
    }, [allParticipants, myUser])

    const changeActiveSpeaker = (newUser: any) => {
        if (activeUser?.userId)
            detachVideoPlayer(activeUser?.userId)
        setTimeout(() => {
            setActiveSpeaker(newUser)
            const usr = client.getUser(newUser.userId)
            if (usr.bVideoOn)
                renderActiveSpeakerVideo(newUser.userId)
        })
    }

    const removeParticipants = () => {
        const newParticipants: any[] = client.getAllUser();
        setAllParticipants(newParticipants);
    };

    const getAllParticipants = () => {
        const newParticipants: any[] = client.getAllUser();
        setAllParticipants(newParticipants);
    };

    const userUpdated = React.useCallback(() => {
        const newParticipants: any[] = client.getAllUser();
        setAllParticipants(newParticipants);
        if (activeUser?.userId && activeUser?.userId.toString() !== "0")
            setActiveSpeaker(newParticipants.find((item: any) => item.userId === activeUser?.userId) || newParticipants[0])
        if (myUser?.userId && myUser?.userId.toString() !== "0")
            setCurrentUser(newParticipants.find((item: any) => item.userId === myUser?.userId))
    }, [activeUser, myUser])


    const renderActiveSpeakerVideo = (userId: any) => {
        const stream = client.getMediaStream();
        stream.attachVideo(userId, VideoQuality.Video_1080P).then((userVideo: any) => {
            document.querySelector('video-player-container[id="video-player-container-public"]')?.appendChild(userVideo)
        }).catch((e: any) => {
            console.log('attach', userId, e)
        })
    }

    const detachVideoPlayer = (payload: any) => {
        if (payload === myUser?.userId) {
            document.querySelector(`video-player-container[id="video-player-container-public"] video-player[node-id="${myUser?.userId}"]`)?.remove()
            document.querySelector(`video-player-container[id="video-player-container-public"] video-player[node-id="0"]`)?.remove()
            return
        }
        const stream = client.getMediaStream();
        stream.detachVideo(payload).then(() => {
            document.querySelector(`video-player-container[id="video-player-container-public"] video-player[node-id="${payload}"]`)?.remove()
            let detachedVideo = document.querySelector(`video-player[node-id="0"]`)
            while (detachedVideo) {
                detachedVideo.remove()
                detachedVideo = document.querySelector(`video-player[node-id="0"]`)
            }
        }).catch((e: any) => {
            console.log('detach', payload, e)
        })
    };

    const videoStateChange = React.useCallback((payload: any) => {
        const stream = client.getMediaStream()
        if (payload.action === 'Start' && props.activeUser?.userId === payload.userId) {
            stream.attachVideo(payload.userId, VideoQuality.Video_1080P).then((userVideo: any) => {
                document.querySelector('video-player-container[id="video-player-container-public"]')?.appendChild(userVideo)
            })
        } else if (payload.action === 'Stop' && props.activeUser?.userId === payload.userId) {
            stream.detachVideo(payload.userId).then(() => {
                document.querySelector(`video-player-container[id="video-player-container-public"] video-player[node-id="${payload.userId}"]`)?.remove()
                let detachedVideo = document.querySelector(`video-player[node-id="0"]`)
                while (detachedVideo) {
                    detachedVideo.remove()
                    detachedVideo = document.querySelector(`video-player[node-id="0"]`)
                }
            });
        }
    }, [props.activeUser])

    React.useEffect(() => {
        client.on("user-updated", userUpdated);
        client.on("user-added", getAllParticipants);
        client.on("user-removed", removeParticipants);
        client.on("active-speaker", onActiveChange);
        client.on('peer-video-state-change', videoStateChange)
        return () => {
            client.off("user-updated", userUpdated);
            client.off("user-added", getAllParticipants);
            client.off("user-removed", removeParticipants);
            client.off("active-speaker", onActiveChange);
            client.off('peer-video-state-change', videoStateChange)
        };
    }, [onActiveChange, userUpdated])
    return (
        <>

        </>
    );
};

export default EventHandler;
